import React from "react";
import Hero from "../homepage/Hero";
import TheGreatSouls from "../homepage/TheGreatSouls";
import TheSupreme from "../homepage/TheSupreme";
import ScaredPlaces from "../homepage/ScaredPlaces";
import DivineCharacteristics from "../homepage/DivineCharacteristics";
import SadhakExperience from "../homepage/SadhakExperience";
import FinalSpiritual from "../homepage/FinalSpiritual";
import SahajYogaCard from "../common/SahajYogaCard";
import Footer from "../common/Footer";
const Home = () => {
  return (
    <>
      <Hero />
      <TheGreatSouls />
      <TheSupreme />
      <ScaredPlaces />
      <DivineCharacteristics />
      <SadhakExperience />
      <FinalSpiritual />
      <SahajYogaCard />
      <Footer />
    </>
  );
};

export default Home;
